import React from "react"
import HelpWidgetChartInteractiveMolecule from "views/molecules/interactive/HelpWidgetChartInteractiveMolecule"
import {
  TextChart,
  TextChartMinor,
} from "components/widgets/ScorePage/widgets/TextCharts"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import ChartBadge from "views/atoms/badges/ChartBadge"
import { round } from "services/units/round"
import ChartWithBadgeWrapperMolecule from "views/molecules/charts/ChartWithBadgeWrapperMolecule"

const ChartSDG13AccessibilityErrorsMolecule = ({
  accessibilityErrors,
  lowerLimit,
  upperLimit,
  showAverage,
  trendBadge,
}) => {
  const { t } = useTranslation()

  const badge = (
    <ChartBadge
      lowerLimit={lowerLimit}
      upperLimit={upperLimit}
      inverse
      value={accessibilityErrors?.average}
    />
  )

  const content = {
    // reference: badge, // todo: actually dont use badge for now, waiting to calculate the limits for uncomment
    kpi: round(accessibilityErrors.total, 0),
    kpi_text: t("analyze:websites.accessibility_errors.title"),
  }

  if (showAverage) {
    content.sub_kpi = accessibilityErrors.average
    content.sub_kpi_text = t("analyze:websites.accessibility_errors.average")
  }

  const content_for_display = <TextChartMinor content={content} />

  return (
    <HelpWidgetChartInteractiveMolecule
      text={t(`analyze:websites.accessibility_errors.help`)}
    >
      <ChartWithBadgeWrapperMolecule trendBadge={trendBadge} color="auto">
        <TextChart content={content_for_display} />
      </ChartWithBadgeWrapperMolecule>
    </HelpWidgetChartInteractiveMolecule>
  )
}

ChartSDG13AccessibilityErrorsMolecule.propTypes = {
  accessibilityErrors: PropTypes.object.isRequired,
  lowerLimit: PropTypes.number,
  upperLimit: PropTypes.number,
  showAverage: PropTypes.bool,
  trendBadge: PropTypes.object,
}

ChartSDG13AccessibilityErrorsMolecule.defaultProps = {
  lowerLimit: 3,
  upperLimit: 6,
  showAverage: false,
  trendBadge: null,
}

export default ChartSDG13AccessibilityErrorsMolecule
